// 登录相关的接口
import fetch from './tjFetch.js'
import abLS from '@/business/abLocalStorage'

const apiConfig = {
  // 判断是否显示认证弹框
  checkForceAuth: `/api/pms/user/auth.api`,
  artificial: `/api/pms/user/artificial.api`
}

const api = {}

const getData = (fromData) => {
  const config = {
    headers: {
      'accessToken': abLS.getAccessToken() || ''
    }
  }
  const data = {
    data: fromData || {},
    params: fromData && fromData.params,
    ...config,
    withCredentials: true
  }
  return data
}

api.checkForceAuth = function(params) {
  return fetch.post(apiConfig.checkForceAuth, getData({ params }))
}
api.artificial = function(params) {
  return fetch.post(apiConfig.artificial, getData(params))
}

export default api
